var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chip',{attrs:{"small":"","dark":"","label":"","outlined":"","color":"#C27D95"},on:{"click":function($event){return _vm.displayAlert()}}},[_vm._v("Day "+_vm._s(_vm.daysPassedSinceStart)+" of "+_vm._s(_vm.totalDays))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }